import About from "components/About";
import AboutSection from "components/AboutSection";
import AboutSection2 from "components/AboutSection2";
import Gallery from "components/common/Gallery";
import Footer from "components/Footer";
import Header from "components/header";
import PathShow from "components/PathShow";
import WhySection from "components/WhySection";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const TermsOfSalePage = () => {
  const [t] = useTranslation("global");

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>{"EMPORIUM POINT | Terms and Conditions"}</title>
        <meta
          name="og:title"
          content={"EMPORIUM POINT | Terms and Conditions"}
        />
      </Helmet>
      <div className="font-[Yekan] mt-[99px] md:mt-[83px]">
        <Header />
        <div className="max-w-4xl mx-auto p-6">
          <h1 className="text-3xl font-bold mb-6">{t("sale.title")}</h1>
          <p className="mb-4">{t("sale.scope")}</p>
          <p className="mb-4">{t("sale.rights")}</p>
          <p>{t("sale.confirmation")}</p>
        </div>
        <Footer />
      </div>
    </>
  );
};

export default TermsOfSalePage;
